<tt-page *ngIf="!!setting">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 sp-0">
            <ng-container *ngTemplateOutlet="selection"></ng-container>
            <ng-container *ngTemplateOutlet="tabs"></ng-container>
        </tt-card>

        <tt-list class="col-xs-12 sp-0" [ttData]="itemsListOperations"></tt-list>

        <tt-card class="col-xs-12 sp-0">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5">
                <ng-container *ngTemplateOutlet="selection"></ng-container>
                <ng-container *ngTemplateOutlet="tabs"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #selection>
    <ng-container *ngIf="!!setting">
        <tt-checkbox ttRememberId="w_operations.show_only_active" ttLabel="show_only_active" [(ttModel)]="setting.show_only_active" (ttModelChange)="onChanged($event, 'show_only_active')"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #tabs>
    <ng-container *ngIf="!!setting">
        <tt-tabs [(ttSelectedId)]="selectedBgOperationsSelection" (ttSelectedIdChange)="onChanged($event, 'direct')">
            <tt-tab ttId="1" ttLabel="operation_direct"></tt-tab>
            <tt-tab ttId="0" ttLabel="operation_indirect"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto [ttText]="'operations_print'" [ttGoto]="'selectreport'" [ttGotoParms]="{ webpage_name: 'operations', argtype: '-', argvalue: '-' }"></tt-button-goto>
    </ng-container>
</ng-template>


<!--<tt-page class="col-xs-12 sp-0 height-full">
    <div ng-if="vm.model.tabletSize.matches === false">
        <tt-card class="col-xs-12 sp-0">
            <tt-checkbox class="col-xs-12 sp-0" tt-label="show_only_active" tt-model="vm.model.setting.show_only_active" tt-change="vm.onChanged($value, 'show_only_active')"></tt-checkbox>
            <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgOperationsSelection.buttons" tt-model="vm.model.bgOperationsSelection.selected" tt-change="vm.selectBgOperationsSelection($value)"></tt-buttons-radio>
        </tt-card>

        <im-list-directive class="col-xs-12 sp-0" list-items="vm.model.itemsListOperations" badge="" ltype="" design-var="s12t0"></im-list-directive>

        <tt-card class="col-xs-12 sp-0">
            <tt-button class="col-xs-12 sp-0" tt-text="operations_new" tt-click="vm.goToFunc('operation')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="operations_print" tt-goto="selectreport" tt-goto-parms="{ webpage_name: 'operations', argtype: '-', argvalue: '-' }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>

    <div class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === true">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-checkbox class="col-xs-12 sp-0" tt-label="show_only_active" tt-model="vm.model.setting.show_only_active" tt-change="vm.onChanged($value, 'show_only_active')"></tt-checkbox>
            <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgOperationsSelection.buttons" tt-model="vm.model.bgOperationsSelection.selected" tt-change="vm.selectBgOperationsSelection($value)"></tt-buttons-radio>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-button-goto class="col-xs-12 sp-0" tt-text="operations_print" tt-goto="selectreport" tt-goto-parms="{ webpage_name: 'operations', argtype: '-', argvalue: '-' }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid ng-if="vm.model.tabletSize.matches === true && vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
